"use strict";
var angular = require("angular");
var TypeaheadProviderService = (function () {
    /* @ngInject */
    function TypeaheadProviderService() {
        var _this = this;
        this.typeaheadProvider = function (input, typeaheadSource, tags, typeaheadPaths) {
            return typeaheadSource.filter(function (source) {
                if (typeaheadPaths.length > 1) {
                    return _this.hasSearchPaths(source, input.toLowerCase(), typeaheadPaths);
                }
                return !!(_this.getPathResult(source, typeaheadPaths[0]).toLowerCase().indexOf(input.toLowerCase()) + 1);
            })
                .filter(function (match) {
                return !tags.some(function (tag) { return angular.equals(tag, match); });
            });
        };
        this.setTagType = function (type, assignmentTypes) {
            switch (type) {
                case "groupAssign":
                    return assignmentTypes.assignGroups;
                case "programAssign":
                    return assignmentTypes.assignPrograms;
                case "instructorAssign":
                    return assignmentTypes.assignInstructors;
                case "instructor":
                    return assignmentTypes.instructors;
                case "program":
                    return assignmentTypes.productGroups.TESTPREP.studyPrograms;
                default:
                    return null;
            }
        };
    }
    TypeaheadProviderService.prototype.hasSearchPaths = function (tag, value, typeaheadPaths) {
        var _this = this;
        return typeaheadPaths.some(function (path) {
            var candidate = _this.getPathResult(tag, path).toLowerCase();
            return !!(candidate.indexOf(value) + 1);
        });
    };
    ;
    TypeaheadProviderService.prototype.getPathResult = function (tag, path) {
        return path.split(/\./).reduce(function (result, step) {
            if (result) {
                return result[step];
            }
        }, tag);
    };
    ;
    return TypeaheadProviderService;
}());
exports.TypeaheadProviderService = TypeaheadProviderService;



/** WEBPACK FOOTER **
 ** ./app/common/typeahead-provider/typeahead-provider.service.ts
 **/